import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-cost-operation',
  templateUrl : './template-cost-operation.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateCostOperation {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
